<div class="sample-doc-wrapper">
	<div *ngIf="!document && !sample" class="title">
		{{currentView | removeUnderscore | titlecase}} Sample
	</div>
	<div *ngIf="document && title" class="title">
		{{title | removeUnderscore | titlecase}}
	</div>
	<div *ngIf="sample && !document" class="title">
		{{title | removeUnderscore | titlecase}}
	</div>
	<div *ngIf="document else sampleTemplate" class="document">
		<ng-container *ngIf="isPdf else defaultTemplate">
			<pdf-viewer
				[autoresize]="true"
				[external-link-target]="'blank'"
				[fit-to-page]="false"
				[original-size]="false"
				[render-text]="true"
				[rotation]="0"
				[show-all]="true"
				[show-borders]="false"
				[src]="document"
				[stick-to-page]="false"
				[zoom-scale]="'page-width'"
				[zoom]="1"
				style="width: 100%; height: 600px;"
			></pdf-viewer>
		</ng-container>
		<ng-template #defaultTemplate>
			<img [src]='document' id="refDocument"/>
		</ng-template>

	</div>
	<ng-template #sampleTemplate>
		<ng-container *ngIf="sample else defaultSample">
			<div class="flex justify-center">
				<img [src]="sample">
			</div>
		</ng-container>
	</ng-template>

	<ng-template #defaultSample>
		<div [ngSwitch]="currentView">
			<div *ngSwitchCase="KycDocumentType.VOTER_CARD" class="flex justify-center">
				<img src="assets/images/svgs/voters-card.svg">
			</div>
			<div *ngSwitchCase="KycDocumentType.DRIVER_LICENSE" class="flex justify-center">
				<img src="assets/images/svgs/driver-license.svg">
			</div>
			<div *ngSwitchCase="KycDocumentType.BANK_STATEMENT" class="flex justify-center">
				<img src="assets/images/svgs/bank-statement.svg">
			</div>
			<div *ngSwitchCase="KycDocumentType.SOLICITOR_LETTER" class="flex justify-center">
				<img src="assets/images/svgs/solicitor-letter.svg">
			</div>
			<div *ngSwitchCase="KycDocumentType.TENANCY_AGREEMENT" class="flex justify-center">
				<img src="assets/images/svgs/tenancy-agreement.svg">
			</div>
			<div *ngSwitchCase="KycDocumentType.UTILITY_BILL" class="flex justify-center">
				<img src="assets/images/svgs/utility-bill.svg">
			</div>
			<div *ngSwitchCase="KycDocumentType.PDF">
				<pdf-viewer
					[autoresize]="true"
					[external-link-target]="'blank'"
					[fit-to-page]="false"
					[original-size]="false"
					[render-text]="true"
					[rotation]="0"
					[show-all]="true"
					[show-borders]="false"
					[src]="document"
					[stick-to-page]="false"
					[zoom-scale]="'page-width'"
					[zoom]="1"
					style="width: 100%; height: 600px;"
				></pdf-viewer>
			</div>
			<div *ngSwitchDefault class="flex justify-center">
			</div>
		</div>
	</ng-template>

	<div (click)="dismiss()" class="m-t-16 addCursor flex justify-center">
		<svg fill="none" height="38" viewBox="0 0 38 38" width="38" xmlns="http://www.w3.org/2000/svg">
			<circle cx="19" cy="19" fill="white" fill-opacity="0.13" r="19"/>
			<path clip-rule="evenodd"
				  d="M12.1513 12.1523C12.6199 11.6836 13.3797 11.6836 13.8483 12.1523L18.9998 17.3037L24.1513 12.1523C24.6199 11.6836 25.3797 11.6836 25.8483 12.1523C26.317 12.6209 26.317 13.3807 25.8483 13.8493L20.6969 19.0008L25.8483 24.1523C26.317 24.6209 26.317 25.3807 25.8483 25.8493C25.3797 26.3179 24.6199 26.3179 24.1513 25.8493L18.9998 20.6978L13.8483 25.8493C13.3797 26.3179 12.6199 26.3179 12.1513 25.8493C11.6826 25.3807 11.6826 24.6209 12.1513 24.1523L17.3027 19.0008L12.1513 13.8493C11.6826 13.3807 11.6826 12.6209 12.1513 12.1523Z"
				  fill="white"
				  fill-rule="evenodd"/>
		</svg>
	</div>
</div>
